var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "preview" }, [
    _c("div", { ref: "wrapper", staticClass: "scroll-outer" }, [
      _c(
        "div",
        { ref: "innerscroll", staticClass: "inner-scroll" },
        [
          _c("FeaturedHeader", { attrs: { scroll: _vm.offY } }),
          _vm._v(" "),
          _c("div", { staticClass: "all-listings" }, [
            _c(
              "div",
              { staticClass: "container n-mx" },
              _vm._l(_vm.rows, function (row) {
                return _c(
                  "CatRow",
                  {
                    key: row.id + row.assets.length,
                    attrs: { rowTitle: row.name },
                  },
                  _vm._l(row.assets, function (asset, aIndex) {
                    return _c("RowCard", {
                      key: aIndex,
                      attrs: {
                        posterSrc: asset.poster,
                        title: asset.name,
                        description: asset.description,
                        moneyTag: _vm.Global.plans[asset.planIndex].name,
                        index: asset.index,
                        progressPerc: asset.progressPerc,
                      },
                    })
                  }),
                  1
                )
              }),
              1
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }